export default __webpack_public_path__ + "static/media/chaise-rectangle-3-breaks.70d2e592.webp";